import * as angular from "angular"
import { groupBy, ICropping, INtrReqNutrients } from "../../../omnia"
import { getTargetNutrientValueFromRequirement, INutritionCalcService } from "../../../services/calcService"
import { StockVm } from "../../../stocks/stockVm"
import { IManureStock, INutritionService, ManureAnalysisProvider, ProductAppInput } from "../../../types"
import { sortReferenceDates } from "../../../utils"
import { IAppReqGrouping } from "../types"
import { CroppingOverride } from "./croppingOverride"
import { ProductApplicationVm } from "./productApplicationVm"

interface ICroppingReq extends INtrReqNutrients {
    CroppingId: number;
}

export class AutocompleteService {

    static Autocomplete(svc: INutritionService, app: ProductApplicationVm) {
        let ac = new AutocompleteService(svc, app);
        ac.doAutoComplete();
    }

    private calcSvc: INutritionCalcService;
    private _manureAnalysis: ManureAnalysisProvider
    private stock: StockVm;

    constructor(private svc: INutritionService, private app: ProductApplicationVm) {
        this.calcSvc = svc.calculationService;
        this._manureAnalysis = svc.manureAnalysis;
        this.stock = app.stock;
    }

    private doAutoComplete(): void {

        let app = this.app;

        if (!app.autoComplete) {
            app.resetRates();
            return;
        }

        var croppings = app.ctxt.getSelectedCropping();
        var applications = app.ctxt.applications
            .filter(p => p !== app)
            .sort((a1, a2) => sortReferenceDates(a1, a2));

        let croppingRequirements: ICroppingReq[] = [];

        // Calculate actual requirement for each cropping
        croppings.forEach(c => {

            let req = <INtrReqNutrients>angular.extend({}, c.planRequirements.crop);

            req = this.calcSvc.calculateClosingRequirements(req, applications.map(a => a.productApp), c.cropping);

            croppingRequirements.push({ ...req, CroppingId: c.croppingId });


        });

        const croppingsList = croppings.map(c => c.cropping);

        let requirementGroupping = groupBy(croppingRequirements, c => this.getAppReqGroupingItem(c, croppingsList), c => c.requirement);

        requirementGroupping = requirementGroupping
            .sort((a, b) => {

                let diff = (a.key.requirement <= 0 ? 1 : 0) - (b.key.requirement <= 0 ? 1 : 0)

                if (!diff) {
                    diff = a.values.length - b.values.length
                }

                if (!diff) {
                    diff = b.key.requirement - a.key.requirement
                }

                return diff

            })

        if (requirementGroupping.length > 0) {

            var baseRequirement: ICroppingReq = requirementGroupping[0].values[0];
            var analysis = requirementGroupping[0].key.analysis;

            app.resetRates();

            var nutrientRate = getTargetNutrientValueFromRequirement(app.targetNutrient, baseRequirement);

            if (app.stock.isManure()) {
                app.productApp.ProductRate = app.getProductRateForNutrientRate(nutrientRate / 1000, analysis);
                app.lastInputUsed = ProductAppInput.ProductRate;
            } else {
                app.productApp.NutrientRate = nutrientRate;
                app.lastInputUsed = ProductAppInput.NutrientRate;
            }

            app.updateTargetModel(app.productApp, false);

            // Override croppings that are not 100% filled
            croppings.forEach(c => {

                var croppingAnalysis = app.analysis;

                if (app.stock.isManure()) {
                    croppingAnalysis = this._manureAnalysis(<IManureStock>app.stock.actualStock, app.productApp, c.cropping)
                }

                var requirement = croppingRequirements.find(r => r.CroppingId === c.cropping.CroppingId);
                var requirementFinal = this.calcSvc.calculateClosingRequirements(requirement, [app.productApp], c.cropping, false);
                var targetNutrientRequirement = getTargetNutrientValueFromRequirement(app.targetNutrient, requirementFinal);

                if (targetNutrientRequirement !== 0) {

                    let ovr = new CroppingOverride(app, c.cropping.CroppingId);
                    app.setOverride(ovr);

                    var nutrientRateOverride = getTargetNutrientValueFromRequirement(app.targetNutrient, requirement);
                    if (app.stock.isManure()) {
                        ovr.ProductRate = app.getProductRateForNutrientRate(nutrientRateOverride / 1000, croppingAnalysis);
                    } else {
                        ovr.NutrientRate = nutrientRateOverride;
                    }
                }

            });

            app.updateOverridesOnModel();

            // Force refresh
            if (app.stock.isManure()) {
                var value = app.productApp.ProductRate;
                app.productRate = -1;
                app.productRate = value;
            } else {
                var value = app.productApp.NutrientRate;
                app.nutrientRate = -1;
                app.nutrientRate = value;
            }

        }
    }

    private getAppReqGroupingItem(requirement: ICroppingReq, croppings: ICropping[]): IAppReqGrouping {

        let app = this.app;
        let analysis = app.analysis;

        if (this.stock.isManure()) {
            var cropping = croppings.find(c => c.CroppingId === requirement.CroppingId);
            analysis = this._manureAnalysis(<IManureStock>this.stock.actualStock, app.productApp, cropping)
        }

        return {
            requirement: getTargetNutrientValueFromRequirement(app.targetNutrient, requirement),
            analysis: analysis
        };
    }

}


